export default __webpack_public_path__ + "static/media/736.2019844d.jpg";